import BaseAssistanceFullImage from './BaseAssistanceFullImage';
export default BaseAssistanceFullImage;
